export default {
    // Thêm mới
    Add: 1,
    // Cập nhật
    Update: 2
};   